import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import {
  Car,
  Shield,
  Wrench,
  Zap,
  CheckCircle,
  ArrowRight,
  Phone,
  Wind
} from 'lucide-react'
import { COMPANY_STATS } from '../constants/stats'

const Services = () => {
  const services = [
    {
      id: 'bottom',
      icon: Car,
      title: 'Обработка днища автомобиля',
      description: 'Комплексная защита днища автомобиля от коррозии, включая арки колес, скрытые полости и все уязвимые места.',
      price: 'от 600 BYN',
      duration: '1-2 дня',
      warranty: '5 лет',
      features: [
        'Тщательная очистка днища от грязи и ржавчины',
        'Обезжиривание всех поверхностей',
        'Нанесение антикоррозийного состава в несколько слоев',
        'Обработка арок колес и скрытых полостей',
        'Защита от влаги и химических реагентов',
        'Контроль качества'
      ],
      materials: ['Dinitrol', 'WURTH'],
      suitableFor: ['Легковые автомобили', 'Внедорожники', 'Коммерческий транспорт']
    },
    {
      id: 'cavities',
      icon: Wrench,
      title: 'Обработка скрытых полостей',
      description: 'Защита внутренних полостей кузова, дверей, капотов и других скрытых мест от коррозии.',
      price: 'от 300 BYN',
      duration: '2-3 часа',
      warranty: '5 лет',
      features: [
        'Диагностика скрытых полостей',
        'Очистка от влаги и загрязнений',
        'Нанесение антикоррозийного состава',
        'Защита от конденсата',
        'Обработка труднодоступных мест',
        'Долгосрочная защита от коррозии'
      ],
      materials: ['Dinitrol', 'WURTH'],
      suitableFor: ['Все автомобили', 'Особенно важна для старых авто', 'Автомобили с пробегом']
    },
    {
      id: 'sandblasting',
      icon: Wind,
      title: 'Пескоструйная очистка кузова автомобиля',
      description: 'Профессиональная очистка кузова и днища автомобиля с помощью пескоструйной обработки для удаления ржавчины, старой краски и загрязнений.',
      price: 'от 600 BYN',
      duration: '1-2 дня',
      warranty: '1 год',
      features: [
        'Полная очистка кузова от ржавчины и старой краски',
        'Очистка днища от коррозии и загрязнений',
        'Подготовка поверхности к покраске',
        'Удаление всех видов загрязнений и налетов',
        'Безопасная обработка без повреждения металла',
        'Высокое качество подготовки поверхности'
      ],
      materials: ['Кварцевый песок', 'Специальные абразивы', 'Защитные материалы'],
      suitableFor: ['Автомобили с ржавчиной', 'Подготовка к покраске', 'Реставрация старых авто'],
      pricing: [
        { service: 'Кузов целиком', price: 'от 800 BYN' },
        { service: 'Днище целиком', price: 'от 600 BYN' }
      ]
    },
    {
      id: 'complex',
      icon: Zap,
      title: 'Комплексная антикоррозийная обработка',
      description: 'Полная защита всего автомобиля от коррозии с максимальной гарантией и скидкой.',
      price: 'от 800 BYN',
      duration: '1-2 дня',
      warranty: '5 лет',
      features: [
        'Все виды обработки в одном пакете',
        'Скидка 15% от общей стоимости',
        'Расширенная гарантия на 5 лет',
        'Бесплатная диагностика',
        'Бесплатная повторная обработка через год',
        'Приоритетное обслуживание'
      ],
      materials: ['Все сертифицированные материалы', 'Индивидуальный подбор', 'Премиум составы'],
      suitableFor: ['Все типы автомобилей', 'Новые автомобили', 'Автомобили с пробегом']
    },
    {
      id: 'body',
      icon: Shield,
      title: 'Защита кузова автомобиля',
      description: 'Защита внешних поверхностей кузова от коррозии, царапин и внешних воздействий.',
      price: 'от 600 BYN',
      duration: '1-2 дня',
      warranty: '1 год',
      features: [
        'Полировка кузова для удаления мелких царапин',
        'Очистка и обезжиривание поверхностей',
        'Нанесение защитного покрытия',
        'Защита от ультрафиолета и химических веществ',
        'Гидрофобное покрытие для отталкивания воды',
        'Долговечная защита от коррозии'
      ],
      materials: ['Ceramic Pro', 'Gtechniq', 'CarPro'],
      suitableFor: ['Все типы кузовов', 'Новые автомобили', 'Автомобили с пробегом']
    }
  ]

  const processSteps = [
    {
      number: '01',
      title: 'Бесплатная диагностика',
      description: 'Осмотр автомобиля, выявление проблемных зон и составление плана обработки'
    },
    {
      number: '02',
      title: 'Подготовка автомобиля',
      description: 'Тщательная очистка, обезжиривание и подготовка всех поверхностей'
    },
    {
      number: '03',
      title: 'Антикоррозийная обработка',
      description: 'Нанесение защитных составов в несколько слоев с соблюдением технологии'
    },
    {
      number: '04',
      title: 'Контроль качества',
      description: 'Проверка качества нанесения и финальная полировка'
    },
    {
      number: '05',
      title: 'Гарантийное обслуживание',
      description: 'Выдача гарантийного талона и рекомендации по уходу'
    }
  ]

  return (
    <div className="page-padding">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary-900 via-primary-800 to-secondary-900 text-white py-20">
        <div className="container-custom text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6"
          >
            Наши услуги
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed"
          >
            Полный спектр услуг по антикоррозийной обработке автомобилей
            с использованием современных технологий и качественных материалов
          </motion.p>
          <div className="mt-6">
            <a href="/anticor-brest" className="underline text-white font-semibold">
              Антикор Брест — подробности и цены
            </a>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="space-y-16">
            {services.map((service, index) => (
              <motion.div
                key={service.id}
                id={service.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
                className="scroll-mt-20"
              >
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                  {/* Content */}
                  <div className={index % 2 === 0 ? 'order-1' : 'order-2'}>
                    <div className="flex items-center space-x-4 mb-6">
                      <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center">
                        <service.icon className="w-8 h-8 text-primary-600" />
                      </div>
                      <div>
                        <h2 className="text-3xl md:text-4xl font-bold text-secondary-900">
                          {service.title}
                        </h2>
                      </div>
                    </div>

                    <p className="text-lg text-secondary-600 mb-6 leading-relaxed">
                      {service.description}
                    </p>

                    {/* Service Details */}
                    {service.pricing ? (
                      <div className="mb-8">
                        <h3 className="text-xl font-semibold text-secondary-900 mb-4">
                          Стоимость услуг:
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          {service.pricing.map((pricing, pricingIndex) => (
                            <div key={pricingIndex} className="text-center p-4 bg-secondary-50 rounded-lg">
                              <div className="text-2xl font-bold text-primary-600 mb-2">
                                {pricing.price}
                              </div>
                              <div className="text-sm text-secondary-600">{pricing.service}</div>
                            </div>
                          ))}
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                          <div className="text-center p-4 bg-secondary-50 rounded-lg">
                            <div className="text-2xl font-bold text-primary-600 mb-2">
                              {service.duration}
                            </div>
                            <div className="text-sm text-secondary-600">Время работы</div>
                          </div>
                          <div className="text-center p-4 bg-secondary-50 rounded-lg">
                            <div className="text-2xl font-bold text-primary-600 mb-2">
                              {service.warranty}
                            </div>
                            <div className="text-sm text-secondary-600">Гарантия</div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                        <div className="text-center p-4 bg-secondary-50 rounded-lg">
                          <div className="text-2xl font-bold text-primary-600 mb-2">
                            {service.price}
                          </div>
                          <div className="text-sm text-secondary-600">Стоимость</div>
                        </div>
                        <div className="text-center p-4 bg-secondary-50 rounded-lg">
                          <div className="text-2xl font-bold text-primary-600 mb-2">
                            {service.duration}
                          </div>
                          <div className="text-sm text-secondary-600">Время работы</div>
                        </div>
                        <div className="text-center p-4 bg-secondary-50 rounded-lg">
                          <div className="text-2xl font-bold text-primary-600 mb-2">
                            {service.warranty}
                          </div>
                          <div className="text-sm text-secondary-600">Гарантия</div>
                        </div>
                      </div>
                    )}

                    {/* Features */}
                    <div className="mb-8">
                      <h3 className="text-xl font-semibold text-secondary-900 mb-4">
                        Что входит в услугу:
                      </h3>
                      <ul className="space-y-3">
                        {service.features.map((feature, featureIndex) => (
                          <li key={featureIndex} className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-primary-500 mr-3 mt-0.5 flex-shrink-0" />
                            <span className="text-secondary-700">{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Materials */}
                    <div className="mb-8">
                      <h3 className="text-xl font-semibold text-secondary-900 mb-4">
                        Используемые материалы:
                      </h3>
                      <div className="flex flex-wrap gap-2">
                        {service.materials.map((material, materialIndex) => (
                          <span
                            key={materialIndex}
                            className="px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-sm font-medium"
                          >
                            {material}
                          </span>
                        ))}
                      </div>
                    </div>

                    {/* Suitable For */}
                    <div className="mb-8">
                      <h3 className="text-xl font-semibold text-secondary-900 mb-4">
                        Подходит для:
                      </h3>
                      <ul className="space-y-2">
                        {service.suitableFor.map((item, itemIndex) => (
                          <li key={itemIndex} className="flex items-center">
                            <div className="w-2 h-2 bg-primary-400 rounded-full mr-3" />
                            <span className="text-secondary-700">{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* CTA */}
                    <div className="flex flex-col sm:flex-row gap-4">
                      <Link
                        to="/contact"
                        className="btn-primary flex items-center justify-center space-x-2"
                      >
                        <span>Записаться</span>
                        <ArrowRight className="w-4 h-4" />
                      </Link>
                      <a
                        href={`tel:${COMPANY_STATS.phoneClean}`}
                        className="btn-secondary flex items-center justify-center space-x-2"
                      >
                        <Phone className="w-4 h-4" />
                        <span>Позвонить</span>
                      </a>
                    </div>
                  </div>

                  {/* Visual */}
                  <div className={index % 2 === 0 ? 'order-2' : 'order-1'}>
                    <div className="bg-gradient-to-br from-primary-50 to-accent-50 rounded-2xl p-8 h-full flex items-center justify-center">
                      <div className="text-center">
                        <div className="w-32 h-32 bg-gradient-to-br from-primary-500 to-accent-500 rounded-full flex items-center justify-center mx-auto mb-6">
                          <service.icon className="w-16 h-16 text-white" />
                        </div>
                        <h3 className="text-2xl font-bold text-secondary-900 mb-4">
                          {service.title}
                        </h3>
                        <div className="space-y-3">
                          {service.pricing ? (
                            <>
                              {service.pricing.map((pricing, pricingIndex) => (
                                <div key={pricingIndex} className="flex items-center justify-between">
                                  <span className="text-secondary-600">{pricing.service}:</span>
                                  <span className="font-bold text-primary-600">{pricing.price}</span>
                                </div>
                              ))}
                              <div className="flex items-center justify-between">
                                <span className="text-secondary-600">Время:</span>
                                <span className="font-bold text-primary-600">{service.duration}</span>
                              </div>
                              <div className="flex items-center justify-between">
                                <span className="text-secondary-600">Гарантия:</span>
                                <span className="font-bold text-primary-600">{service.warranty}</span>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="flex items-center justify-between">
                                <span className="text-secondary-600">Стоимость:</span>
                                <span className="font-bold text-primary-600">{service.price}</span>
                              </div>
                              <div className="flex items-center justify-between">
                                <span className="text-secondary-600">Время:</span>
                                <span className="font-bold text-primary-600">{service.duration}</span>
                              </div>
                              <div className="flex items-center justify-between">
                                <span className="text-secondary-600">Гарантия:</span>
                                <span className="font-bold text-primary-600">{service.warranty}</span>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="section-padding bg-secondary-50">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-secondary-900 mb-4">
              Как проходит работа
            </h2>
            <p className="text-lg text-secondary-600 max-w-3xl mx-auto">
              Мы используем проверенную технологию, которая гарантирует
              качественный результат и долговечную защиту
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
            {processSteps.map((step, index) => (
              <motion.div
                key={step.number}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="text-center relative"
              >
                <div className="w-20 h-20 bg-gradient-to-br from-primary-500 to-accent-500 rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold text-2xl">
                  {step.number}
                </div>
                <h3 className="text-xl font-semibold text-secondary-900 mb-2">
                  {step.title}
                </h3>
                <p className="text-secondary-600 text-sm">
                  {step.description}
                </p>

                {index < processSteps.length - 1 && (
                  <div className="hidden lg:block absolute top-10 left-full w-full h-0.5 bg-gradient-to-r from-primary-500 to-accent-500 transform translate-x-4" />
                )}
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-gradient-to-r from-primary-600 to-accent-600 text-white">
        <div className="container-custom text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Готовы защитить ваш автомобиль?
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Запишитесь на антикоррозийную обработку прямо сейчас и получите
              скидку 10% на первый визит
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/contact" className="btn-accent">
                Записаться сейчас
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  )
}

export default Services
